 <template>
  <v-card>
    <v-container>
      <v-row>
        <v-card-title>
          <h5> {{ student.grade().toJapanese() }}</h5>
        </v-card-title>
        <v-card-title>
          <h5>{{ student.genderInJapanese() }}</h5>
        </v-card-title>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                最寄り駅
              </v-list-item-subtitle>
              <v-list-item-title>
                {{ student.nearestStation }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-subtitle>
              希望時間帯
            </v-list-item-subtitle>
          </v-list-item>
          <v-chip
            v-for="schedule in student.availableSchedulesToStrings()"
            :key="schedule"
            class="ma-2"
            outlined
          >
            {{ schedule }}
          </v-chip>
        </v-list>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row justify="center">
        <StatusConditions
          :student="student"
          @request="request"
          @cancel="cancel"
        />
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import StatusConditions from '@/components/organisms/teacher/StatusConditions.vue'
import { firestore } from '@/repository/client/firestore.js'
import { RequestRepository } from '@/repository/RequestRepository.js'

export default {
  name: "StudentsList",
  props: {
    student: Object,
  },
  components: {
    'StatusConditions': StatusConditions,
  },
  methods: {
    request() {
      this.$emit("request", this.student)
    },
    cancel() {
      this.$emit("cancel", this.student)
    },
  }

}
</script>
